import React from 'react';
import { useMemo } from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import AmazonInspectorCredentialsForm from './AmazonInspectorCredentialsForm';
import AmazonInspectorMappingForm from './AmazonInspectorMappingForm';

const AmazonInspectorConfigListing = (props) => {
    
    const columns = useMemo(() => [{
        title: "AWS Account",
        dataIndex: "awsAccount",
        width: 240,
    }, {
        title: "Region",
        dataIndex: "region",
        width: 100,
    }], [])

    return (
        <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={AmazonInspectorMappingForm}
        CredentialsForm={AmazonInspectorCredentialsForm}
        extraColumns={columns}
        displayComponentName={'AWS Account'}
     />
    );
}

export default AmazonInspectorConfigListing;